import { FormkitFacebook } from "@/assets/icons/formkit-facebook";
import { FormkitInstagram } from "@/assets/icons/formkit-instagram";
import { FormkitLinkedin } from "@/assets/icons/formkit-linkedin";

export const socialLinks = [
  {
    name: "Instagram",
    icon: FormkitInstagram,
    href: "https://www.instagram.com/mudo_club_argenteuil/",
  },
  {
    name: "Facebook",
    icon: FormkitFacebook,
    href: "https://www.facebook.com/MudoClub",
  },
  {
    name: "Linkedin",
    icon: FormkitLinkedin,
    href: "https://www.taap.it/H067Of",
  },
];
